import ChallengesLeaderboardTable from './ChallengesLeaderboardTable';

export default ChallengesLeaderboardTable;
